import Delete from "./delete";
import Manage from "./manage";

export const Target = { Manage, Delete };
